export const createChapterUrl: (baseUrl?: string, durationInSeconds?: number | null) => string = (
	baseUrl?: string,
	durationInSeconds?: number | null,
) => {
	return `${baseUrl}?t=${durationInSeconds}`;
};
